import { ChartType } from 'chart.js';

export function isDoughnutOrPieChart(chartType: ChartType): boolean {
  return chartType === 'pie' || chartType === 'doughnut';
}
